import { FC } from "react";
import { Box } from "@mui/material";
import CustomSkeleton from "../custom-skeleton/CustomSkeleton";

const DraggableItemSkeleton: FC = () => {
  const dummyArray = Array.from({ length: 5 });

  return (
    <Box>
      {dummyArray.map((_, i) => (
        <Box
          key={i}
          className="full-width"
          sx={{ mb: 2 }}
        >
          <CustomSkeleton
            variant="rectangular"
            height={35}
            sx={{ borderRadius: "12px" }}
          />
        </Box>
      ))}
    </Box>
  );
};

export default DraggableItemSkeleton;
